import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, vModelText as _vModelText, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-54ffe226"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ui-full" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ui-button-content" }, " Confirmar ", -1))
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = { class: "ant-row" }
const _hoisted_5 = { class: "ant-col ant-col-xs-24 ant-col-xl-20" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "",
  title: "Característica"
}, "Característica", -1))
const _hoisted_7 = { class: "ant-col ant-col-xs-24 ant-col-xl-4" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ui-button-content" }, " Adicionar ", -1))
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = { key: 1 }
const _hoisted_11 = { class: "ui-titulo-destaque ui-move" }
const _hoisted_12 = { class: "ui-daj-center" }
const _hoisted_13 = { class: "ss-titulo-destaque ss-texto-centralizado" }
const _hoisted_14 = ["onClick"]
const _hoisted_15 = {
  key: 0,
  class: "ui-variacao-selecionar-caracteristicas"
}
const _hoisted_16 = {
  key: 1,
  class: "ui-variacao-selecionar-caracteristicas"
}
const _hoisted_17 = { key: 2 }
const _hoisted_18 = { key: 3 }
const _hoisted_19 = ["onUpdate:modelValue"]
const _hoisted_20 = { key: 4 }
const _hoisted_21 = ["value", "onChange"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icone = _resolveComponent("icone")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_mensagem_sem_dados = _resolveComponent("mensagem-sem-dados")!
  const _component_a_checkbox = _resolveComponent("a-checkbox")!
  const _component_card = _resolveComponent("card")!
  const _component_draggable = _resolveComponent("draggable")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_modal, {
      keyboard: false,
      centered: "",
      width: 1000,
      visible: _ctx.state.apresentarModalVariacao,
      "onUpdate:visible": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.state.apresentarModalVariacao) = $event)),
      title: "Novas variações do produto"
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", null, [
          _createElementVNode("button", {
            class: "ui-button -second",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.state.apresentarModalVariacao = false))
          }, " Voltar "),
          _createElementVNode("button", {
            class: "ui-button -primary",
            type: "button",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.criaDefinicoesComVariacoes()))
          }, _hoisted_3)
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_a_form, { layout: "vertical" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_component_a_form_item, null, {
                  label: _withCtx(() => [
                    _hoisted_6,
                    _createVNode(_component_a_tooltip, {
                      placement: "top",
                      title: "Defina uma ou mais características e selecione quais itens correspondem a variação de seu produto que vai ter informações específicas de estoque, preços, imagens e outros..."
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_icone, {
                          class: "ui-icone-informacao",
                          nome: "informacao-campo"
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_a_select, {
                      class: "ui-full",
                      value: _ctx.state.codigoCaracteristicaSelecionada,
                      "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state.codigoCaracteristicaSelecionada) = $event)),
                      allowClear: true,
                      placeholder: "Selecione",
                      optionFilterProp: "label",
                      options: _ctx.state.listaCaracteristicas
                    }, null, 8, ["value", "options"])
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_7, [
                _createVNode(_component_a_form_item, { label: " " }, {
                  default: _withCtx(() => [
                    _createElementVNode("button", {
                      class: "ui-button -primary ui-mh-32 ui-full",
                      type: "button",
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.adicionarCaracteristica()))
                    }, _hoisted_9)
                  ]),
                  _: 1
                })
              ])
            ]),
            (_ctx.state.caracteristicasVariacao.length <= 0)
              ? (_openBlock(), _createBlock(_component_mensagem_sem_dados, {
                  key: 0,
                  mensagem: "Nenhuma característica foi adicionada ainda"
                }))
              : (_ctx.state.caracteristicasVariacao.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                    _createVNode(_component_draggable, {
                      modelValue: _ctx.state.caracteristicasVariacao,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.state.caracteristicasVariacao) = $event)),
                      "item-key": "codigo",
                      handle: ".ui-move",
                      class: "ant-row ui-variacao-caracteristicas"
                    }, {
                      item: _withCtx(({element,index}) => [
                        (_openBlock(), _createElementBlock("div", {
                          key: element.codigo,
                          class: "ant-col ant-col-xs-24 ant-col-xl-6"
                        }, [
                          _createVNode(_component_card, {
                            altura: 450,
                            titulo: (index + 1) + 'ª Característica'
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_11, [
                                _createElementVNode("div", _hoisted_12, [
                                  _createElementVNode("span", _hoisted_13, _toDisplayString(element.nome), 1),
                                  _createElementVNode("a", {
                                    class: "ui-daj-center",
                                    title: "Remover característica",
                                    href: "#",
                                    onClick: ($event: any) => (_ctx.removerCaracteristica(index))
                                  }, [
                                    _createVNode(_component_icone, {
                                      class: "ui-icone-informacao",
                                      nome: "excluir"
                                    })
                                  ], 8, _hoisted_14)
                                ])
                              ]),
                              (element.tipo === _ctx.ETipoCaracteristica.ListaSimples)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(element.itens, (itemCaracteristica) => {
                                      return (_openBlock(), _createElementBlock("div", {
                                        key: itemCaracteristica.codigoItem
                                      }, [
                                        _createVNode(_component_a_checkbox, {
                                          checked: itemCaracteristica.selecionado,
                                          "onUpdate:checked": ($event: any) => ((itemCaracteristica.selecionado) = $event)
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(itemCaracteristica.valor), 1)
                                          ]),
                                          _: 2
                                        }, 1032, ["checked", "onUpdate:checked"])
                                      ]))
                                    }), 128))
                                  ]))
                                : (element.tipo === _ctx.ETipoCaracteristica.Cores)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(element.itens, (itemCaracteristica) => {
                                        return (_openBlock(), _createElementBlock("div", {
                                          style: {"display":"flex","align-items":"center"},
                                          key: itemCaracteristica.codigoItem
                                        }, [
                                          _createElementVNode("span", {
                                            style: _normalizeStyle('width: 16px;height: 16px;border-radius: 3px;margin-right: 6px;background-color:' + itemCaracteristica.apresentacao)
                                          }, null, 4),
                                          _createVNode(_component_a_checkbox, {
                                            checked: itemCaracteristica.selecionado,
                                            "onUpdate:checked": ($event: any) => ((itemCaracteristica.selecionado) = $event)
                                          }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(itemCaracteristica.valor), 1)
                                            ]),
                                            _: 2
                                          }, 1032, ["checked", "onUpdate:checked"])
                                        ]))
                                      }), 128))
                                    ]))
                                  : (element.tipo === _ctx.ETipoCaracteristica.ListaSubItens)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(element.itens, (itemCaracteristica) => {
                                          return (_openBlock(), _createElementBlock("div", {
                                            class: "ui-variacao-selecionar-caracteristicas",
                                            key: itemCaracteristica.codigoItem
                                          }, [
                                            _createElementVNode("span", null, _toDisplayString(itemCaracteristica.valor), 1),
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(itemCaracteristica.subItens, (subItemCaracteristica) => {
                                              return (_openBlock(), _createElementBlock("div", {
                                                key: subItemCaracteristica.codigoSubItem
                                              }, [
                                                _createVNode(_component_a_checkbox, {
                                                  checked: subItemCaracteristica.selecionado,
                                                  "onUpdate:checked": ($event: any) => ((subItemCaracteristica.selecionado) = $event)
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createTextVNode(_toDisplayString(subItemCaracteristica.valor), 1)
                                                  ]),
                                                  _: 2
                                                }, 1032, ["checked", "onUpdate:checked"])
                                              ]))
                                            }), 128))
                                          ]))
                                        }), 128))
                                      ]))
                                    : (element.tipo === _ctx.ETipoCaracteristica.Texto)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                                          _withDirectives(_createElementVNode("input", {
                                            type: "text",
                                            class: "ant-input",
                                            maxlength: "250",
                                            "onUpdate:modelValue": ($event: any) => ((element.valor) = $event)
                                          }, null, 8, _hoisted_19), [
                                            [_vModelText, element.valor]
                                          ])
                                        ]))
                                      : (element.tipo === _ctx.ETipoCaracteristica.Numero || element.tipo === _ctx.ETipoCaracteristica.Decimal)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                                            _createElementVNode("input", {
                                              type: "number",
                                              class: "ant-input",
                                              value: Number(element.valor),
                                              onChange: ($event: any) => (element.valor = String($event))
                                            }, null, 40, _hoisted_21)
                                          ]))
                                        : _createCommentVNode("", true)
                            ]),
                            _: 2
                          }, 1032, ["titulo"])
                        ]))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]))
                : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["visible"])
  ]))
}